import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DOUBLET_PROVIDER_SERVICE } from 'src/app/lib/shared/interfaces';
import { Customer } from '../../../classes';
import { CreateCustomerService } from '../../../services/create-customer-service';
import { CustomerService } from '../../../services/customer.service';

@Component({
  selector: 'app-create-customer-dialog',
  templateUrl: './create-customer-dialog.component.html',
  styleUrls: ['./create-customer-dialog.component.css'],
  providers: [
    { provide: DOUBLET_PROVIDER_SERVICE, useClass: CreateCustomerService }
  ]
})
export class CreateCustomerDialogComponent implements OnDestroy, OnInit {

  formGroup: FormGroup;

  private _subscriptions: Subscription[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) private _data: CreateCustomerDialogComponentConfiguration,
    @Inject(DOUBLET_PROVIDER_SERVICE) public service: CreateCustomerService,
    private _ref: MatDialogRef<CreateCustomerDialogComponent>,
    private _formBuilder: FormBuilder,
    private _customerService: CustomerService,
    private _snackBar: MatSnackBar,
    private _router: Router
  ) {
    this.formGroup = this._formBuilder.group(new Customer());
  }

  close = () => this._ref.close();

  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this._subscriptions.push(...[
      this.service.doubletClicked$.subscribe(() => this.close())
    ])
  }

  saveCustomer() {
    if (this.formGroup.invalid) return;
    this._customerService.createCustomer(this.formGroup.value, null).subscribe(
      (customer: Customer) => {
        if(!this._data || !this._data.preventNavigation) this._router.navigate(['/customer-details', customer.customerid]);
        this._ref.close(customer);
      },
      (error: HttpErrorResponse) => this._snackBar.open(`Fehler beim Erstellen des Kunden (${error.message})`, 'Abbrechen')
    );
  }

}

export class CreateCustomerDialogComponentConfiguration {
  preventNavigation: boolean;
}
